var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.2188,
    r: 14,
    stroke: "#7D5416",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55545 21.552C7.63353 22.9894 9.06071 24.1279 10.7018 24.8595C12.3429 25.5911 14.1436 25.8917 15.9334 25.7328C17.7232 25.5739 19.4427 24.9608 20.9293 23.9515C22.4158 22.9421 23.6201 21.57 24.4281 19.9651C25.236 18.3602 25.6209 16.5757 25.5463 14.7804C25.4717 12.9851 24.9401 11.2386 24.0018 9.7063C23.0634 8.17397 21.7495 6.90652 20.1843 6.02401C18.6192 5.14149 16.8547 4.67312 15.0579 4.66325L14.9999 15.2186L6.55545 21.552Z",
    fill: "#7D5416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.4176350be9cb849e715ebc87a6467d69.svg";
export { ForwardRef as ReactComponent };